<template>
  <!-- :title="$t('identity.imgUpload')" -->
  <el-dialog class="role-dialog"
             :visible.sync="visible"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="450px"
             top="10px">
    <div class="wrapper">
      <div class="model"
           v-show="model"
           @click="model = false">
        <div class="model-show">
          <img alt="" :src="modelSrc"
               alt="">
        </div>
      </div>
      <div class="content">
        <div class="show-info">
<!--          <h2>{{$t('identity.imgUploadTip')}}</h2>-->
          <h2>Banner</h2>
          <div class="test">
            <vueCropper ref="cropper2"
                        :img="example2.img"
                        :outputSize="example2.size"
                        :outputType="example2.outputType"
                        :info="example2.info"
                        :canScale="example2.canScale"
                        :autoCrop="example2.autoCrop"
                        :autoCropWidth="example2.autoCropWidth"
                        :autoCropHeight="example2.autoCropHeight"
                        :fixed="example2.fixed"
                        :fixedNumber="example2.fixedNumber"
                        :enlarge="4"></vueCropper>
          </div>
          <label class="btn"
                 for="upload3">上传</label>
          <input type="file"
                 id="upload3"
                 style="position:absolute; clip:rect(0 0 0 0);"
                 accept="image/png, image/jpeg, image/gif, image/jpg"
                 @change="uploadImg($event,2)">
          <button @click="finish2()"
                  class="btn">裁剪</button>
          <button class="save-btn btn"
                  @click="cancel()">取消</button>
          <button class="save-btn btn"
                  @click="save()">保存</button>
        </div>
      </div>

    </div>
  </el-dialog>
</template>
<script>
import { VueCropper } from 'vue-cropper'

import ImageCompressor from 'image-compressor.js' // 引入
export default {
  components: {
    VueCropper
  },
  data() {
    return {
      model: false,
      modelSrc: '',
      crap: false,
      previews: {},
      form: {
        head: ''
      },
      example2: {
        // img的路径自行修改
        img: '$oss.url + \'/\' + form.head ',
        info: true,
        size: 1,
        outputType: 'png',
        canScale: true,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixed: false,
        // 真实的输出宽高
        infoTrue: true,
        fixedNumber: [22, 10]
      },
      downImg: '#',
      visible: false,
      imgType: 'image/jpeg',
      imgFile: '',
      userId: '',
      newbuild: ''
    }
  },
  methods: {
    init(userId, newbuild) {
      this.visible = true
      this.$nextTick(() => {
        this.modelSrc = ''
        this.example2.img = ''
        this.imgFile = ''
        this.example2 = {
          // img的路径自行修改
          img: '$oss.url + \'/\' + form.head ',
          info: true,
          size: 1,
          outputType: 'png',
          canScale: true,
          autoCrop: true,
          // 只有自动截图开启 宽度高度才生效
          autoCropWidth: 300,
          autoCropHeight: 300,
          fixed: true,
          // 真实的输出宽高
          infoTrue: true,
          fixedNumber: [22, 10],
          userForm: {}
        }
        if (newbuild) {
          this.newbuild = '1'
        } else {
          this.newbuild = ''
        }
        this.userId = userId
        let test = document.getElementById('upload3')
        test.value = ''
        this.$refs.cropper2.imgs = ''
        this.$refs.cropper2.clearCrop()
      })
    },
    // 点击裁剪，这一步是可以拿到处理后的地址
    finish2() {
      this.$refs.cropper2.getCropData((data) => {
        this.modelSrc = data
        this.model = false
        // 裁剪后的图片显示
        this.example2.img = this.modelSrc
        // this.toBlob(data)
      })
    },
    uploadImg(e, num) {
      console.log('uploadImg')
      console.log(e)
      console.log(num)
      // 上传图片
      // debugger
      this.example2.img = ''
      if (e.target.files[0] !== undefined) {
        let file = e.target.files[0]
        let size = file.size
        if (size > 1024 * 1024 * 4) {
          this.$alert(this.$t('img.maxSizeTow'), this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
          let test = document.getElementById('upload3')
          test.value = ''
          this.$refs.cropper2.imgs = ''
          this.$refs.cropper2.clearCrop()
          return false
        }
        if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
          this.$alert(this.$t('img.type'), this.$t('prompt.title')).then((res) => {
            console.log(res)
          }).catch((err) => {
            console.log(err)
          })
          let test = document.getElementById('upload3')
          test.value = ''
          this.$refs.cropper2.imgs = ''
          this.$refs.cropper2.clearCrop()
          return false
        }
        this.imgFile = file
        this.imgType = file.type
        let reader = new FileReader()
        reader.onload = (e) => {
          let data
          data = e.target.result
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.option.img = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        // 转化为base64
        // reader.readAsDataURL(file)
        // 转化为blobcs
        reader.readAsArrayBuffer(file)
      }
    },
    // base64转blob
    toBlob(ndata) {
      // ndata为base64格式地址
      let arr = ndata.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    save() {
      let _this = this
      if (this.imgFile === '') {
        return false
      }
      this.$refs.cropper2.getCropData((data) => {
        this.modelSrc = data
        this.model = false
        // 裁剪后的图片显示
        this.example2.img = this.modelSrc
        // var form = document.forms[0]
        // var formData = new FormData(form)
        let formData = new FormData() // 这里连带form里的其他参数也一起提交了,如果不需要提交其他参数可以直接FormData无参数的构造函数
        let arr = this.example2.img.split(',')
        let mime = ''
        let file
        if (arr.length > 1) {
          mime = arr[0].match(/:(.*?);/)[1]
          var index1 = mime.lastIndexOf('/')
          mime = mime.substring(index1 + 1)
          // convertBase64UrlToBlob函数是将base64编码转换为Blob
          file = this.toBlob(this.example2.img)
          // var fileOfBlob = new File([blob], 'image.' + mime)
          formData.append('file', file, 'image.' + mime) // append函数的第一个参数是后台获取数据的参数名,和html标签的input的name属性功能相同
        } else {
          file = this.imgFile
          formData.append('file', file)
        }
        debugger
        //此处为压缩图片方法
        let image = new Image() //新建一个img标签（还没嵌入DOM节点)
        image.src = this.modelSrc
        image.onload = function () {
          let canvas = document.createElement('canvas'),
            context = canvas.getContext('2d');
          let x = image.width / 300;  //压缩倍数
          let imageWidth = 0
          let imageHeight = 0
          if (image.width > 300) {
            imageWidth = image.width / x;   //压缩后图片的大小
            imageHeight = image.height / x;
          } else {
            imageWidth = image.width / 1;   //不进行压缩大小
            imageHeight = image.height / 1;
          }
          let data = ''
          canvas.width = imageWidth
          canvas.height = imageHeight
          context.drawImage(image, 0, 0, imageWidth, imageHeight)
          data = canvas.toDataURL('image/' + mime)

          // if (file.size / 1000 > 500) {
          //   this.$alert(this.$t('img.maxSizeBack'), this.$t('prompt.title')).then(() => {
          //   }).catch(() => { })
          //   return false
          // }
          //此处为上传图片到服务器 所传图片值为data
          _this.modelSrc = data
          file = _this.toBlob(data)
          // var fileOfBlob = new File([blob], 'image.' + mime)

          let formData = new FormData();
          formData.append('file', file, 'image.' + mime)
          _this.$request.post('/learning/courseinfo/picupload', formData).then((res, total, code, data) => {
            if (_this.newbuild !== '1') {
              _this.userForm = _this.getStorage(_this.GLOBAL.USER_DATA)
              _this.userForm.headurl = res
              _this.setStorage(_this.GLOBAL.USER_DATA, _this.userForm)
            } else {
              _this.userForm = _this.getStorage(_this.GLOBAL.USER_DATA)
            }
            _this.modelSrc = ''
            _this.visible = false
            let urlform = {
              url: res,
              userId: _this.userForm.userId
            }
            _this.$emit('refreshImg', urlform)
          }).catch((err) => {
            console.log(err)
          })

        }


        // // eslint-disable-next-line no-new
        // new ImageCompressor(file, {
        //   quality: 0.6,
        //   success(result) {
        //     if (result.size / 1000 > 500) {
        //       this.$alert(this.$t('img.maxSizeBack'), this.$t('prompt.title')).then(() => {
        //       }).catch(() => { })
        //     }
        //     const formData = new FormData() // FormData学习地址 https://developer.mozilla.org/zh-CN/docs/Web/API/FormData
        //     formData.append('file', result, result.name)
        //   },
        //   error(e) {
        //     console.log(e.message)
        //   }
        // })
        // this.$request.post('/sys/config/imgUpload', formData).then((res, total, code, data) => {
        //   if (this.newbuild !== '1') {
        //     this.userForm = this.getStorage(this.GLOBAL.USER_DATA)
        //     this.userForm.headurl = res
        //     this.setStorage(this.GLOBAL.USER_DATA, this.userForm)
        //   } else {
        //     this.userForm = this.getStorage(this.GLOBAL.USER_DATA)
        //   }
        //   this.modelSrc = ''
        //   this.visible = false
        //   let urlform = {
        //     url: res,
        //     userId: this.userForm.userId
        //   }
        //   this.$emit('refreshImg', urlform)
        // }).catch(() => {
        // })
      })
    },
    // 取消
    cancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.content {
  margin: auto;
  width: 250px;
  margin-bottom: 20px;
}

.test-button {
  display: flex;
  flex-wrap: wrap;
}
.save-btn {
  float: right;
}
.btn {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #c0ccda;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 20px 10px 0px 0px;
  padding: 9px 10px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #1b69d4;
  border-color: #1b69d4;
  transition: all 0.2s ease;
  text-decoration: none;
  user-select: none;
}

.des {
  line-height: 30px;
}

code.language-html {
  padding: 10px 20px;
  margin: 10px 0px;
  display: block;
  background-color: #333;
  color: #fff;
  overflow-x: auto;
  font-family: Consolas, Monaco, Droid, Sans, Mono, Source, Code, Pro, Menlo,
    Lucida, Sans, Type, Writer, Ubuntu, Mono, sans-serif;
  border-radius: 5px;
  white-space: pre;
}

.show-info {
  margin-bottom: 50px;
}

.show-info h2 {
  color: #333;
  text-align: center;
  font-size: 16px;
  line-height: 30px;
}

.title {
  display: block;
  text-decoration: none;
  text-align: center;
  line-height: 1.5;
  margin: 20px 0px;
  background-image: -webkit-linear-gradient(
    left,
    #3498db,
    #f47920 10%,
    #d71345 20%,
    #f7acbc 30%,
    #ffd400 40%,
    #3498db 50%,
    #f47920 60%,
    #d71345 70%,
    #f7acbc 80%,
    #ffd400 90%,
    #3498db
  );
  color: transparent;
  -webkit-background-clip: text;
  background-size: 200% 100%;
  animation: slide 5s infinite linear;
  font-size: 40px;
}

.test {
  height: 250px;
}

.model {
  position: fixed;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.model-show {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}

.model img {
  display: block;
  margin: auto;
  max-width: 80%;
  user-select: none;
  background-position: 0px 0px, 10px 10px;
  background-size: 20px 20px;
  background-image: linear-gradient(
      45deg,
      #eee 25%,
      transparent 25%,
      transparent 75%,
      #eee 75%,
      #eee 100%
    ),
    linear-gradient(45deg, #eee 25%, white 25%, white 75%, #eee 75%, #eee 100%);
}

.c-item {
  display: block;
  padding: 10px 0;
  user-select: none;
}

@keyframes slide {
  0% {
    background-position: 0 0;
  }

  100% {
    background-position: -100% 0;
  }
}

@media screen and (max-width: 1000px) {
  .content {
    max-width: 90%;
    margin: auto;
  }

  .test {
    height: 400px;
  }
}
</style>
